import script from "./expert.vue?vue&type=script&setup=true&lang=js"
export * from "./expert.vue?vue&type=script&setup=true&lang=js"

import "./expert.vue?vue&type=style&index=0&id=c6e32a22&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6e32a22"]])

export default __exports__